import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AdminType } from './models';
import { TenantService } from './modules/tenant/tenant.service';
import { AuthenticationService } from './services/authentication.service';
import { Title } from '@angular/platform-browser';



declare const $: any;
@Component({
  selector: 'app-root',
  template: `<ng-progress [spinner]="false"></ng-progress>
              <router-outlet></router-outlet>`,
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

  constructor(private router: Router,
    private authService: AuthenticationService,
    private tenantService: TenantService,
    private titleService: Title) { }

  ngOnInit(): void {
    this.router.events.subscribe(evt => {
      if (evt instanceof NavigationStart) {
        //  console.log(this.router.url);
      }

      if (evt instanceof NavigationEnd) {
        // console.log(this.router.url);
        // $("html, body").animate({ scrollTop: 0 }, "slow");
        $(window).scrollTop(0);
      }

    });


    const envPrefix = environment.production ? '' : environment.APP_ENV === 'staging' ? '[Stage] ' : '[Dev] ';
      const baseTitle = location.host.includes('admin') ? 'Admin|Super' : location.host.includes('subscriber') || location.host.includes('operator') ? 'Admin|Operator' : location.host.includes('organization') ? 'Admin|Organization' : 'Admin|Platform';
      this.titleService.setTitle(`${envPrefix}${baseTitle}`);

    if (localStorage.getItem('SuperAdminAuthToken') || localStorage.getItem('SubscriberAdminAuthToken') || localStorage.getItem('OrganizationAdminAuthToken')) {
    } else {
      if (location.host.includes('admin')) {
        this.router.navigate(['/super-admin/login']);
      } else if (location.host.includes('subscriber') || location.host.includes('operator')) {
        this.router.navigate(['/subscriber/login']);
      } else if (location.host.includes('platform') || location.host.includes('organization')) {
        this.router.navigate(['/organization/login']);
      } else {
        this.router.navigate(['/404']);
      }
    }

  }

}
